import { useMutation, useQueryClient } from '@tanstack/react-query'

import { dataOrThrow, type PostVitalsBody } from '@snootsvet/shared'

import { useOsApi } from '@/frontend/hooks/api/use-os-api'

/** Records a new vitals entry for a patient. */
export function useCreateVitals() {
  const api = useOsApi()
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (body: PostVitalsBody) => {
      return dataOrThrow(await api.post('/vitals', { body })).vitals
    },
    onSuccess: (vitals) => {
      queryClient.invalidateQueries({ queryKey: ['patient-vitals', vitals.patientId] })
      queryClient.invalidateQueries({ queryKey: ['patient-timeline', vitals.patientId] })
      if (vitals.consultationId) {
        queryClient.invalidateQueries({ queryKey: ['consultation', vitals.consultationId] })
      }
    },
  })
}
